/**
 * @file    useWidgetActions
 * @scope   SHARED
 * @summary Strategy dispatcher for widget actions: runs the handler registered for the current
 *          action and resets the action to NONE.
 * @consumes WidgetContext
 * @produces Nothing.
 * @sideEffects Whatever the handlers do; writes `action: NONE` to the widget context.
 */
import { useEffect } from 'react';
import { useWidgetContext } from 'contexts/WidgetProvider';
import { WidgetAction } from 'models/WidgetModel';

export type WidgetActionHandlers = Partial<Record<string, () => void>>;

export const useWidgetActions = (handlers: WidgetActionHandlers) => {
  const { action, setState } = useWidgetContext();

  useEffect(() => {
    const handler = handlers[action];
    if (!handler) return;
    handler();
    setState({ action: WidgetAction.NONE });
  }, [action]);
};
